<script setup lang="ts">
import { ExclamationCircleIcon, DocumentTextIcon } from '@heroicons/vue/solid'
import { i18n } from '../../../localization'
import Alert from '../../base/Alert.vue'
import { navigateTo, useLegalAccountNavigationState } from '../../../utilities/account/useAccountNavigationLegal'

const navigationState = useLegalAccountNavigationState()
</script>

<template>
    <Alert
        :title-text="i18n.global.t('signatures.pending_signatures')"
        :description-text="i18n.global.t('signatures.pending_signatures_description')"
        :show-button="navigationState.page !== 'Signatures'"
        :button-text="i18n.global.t('signatures.sign_documents')"
        @click-button="navigateTo('Signatures')">
        <template #icon>
            <DocumentTextIcon class="h-12 w-12 text-gray-300"></DocumentTextIcon>
            <ExclamationCircleIcon
                class="absolute bottom-0 right-[-5px] h-6 w-6 rounded-full bg-white text-red-400"></ExclamationCircleIcon>
        </template>
    </Alert>
</template>

<style scoped></style>
